<template>
  <div id="July2024" class="202407 relative">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202407/menu/right.png" class="object-contain w-full">
      </a>
      <a class="block px-3">
        <img src="~@/assets/images/202407/menu/menu-bar-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202407/menu/menu-bar-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202407/menu/menu-bar-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202407/menu/menu-bar-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202407/menu/menu-bar-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan3')">
        <img src="~@/assets/images/202407/menu/menu-bar-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202407/menu/menu-bar-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan4')">
        <img src="~@/assets/images/202407/menu/menu-bar-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202407/menu/menu-bar-on_05.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#July2024')">
        <img src="~@/assets/images/202407/menu/menu-bar-off_06.png" class="off object-contain">
        <img src="~@/assets/images/202407/menu/menu-bar-on_06.png" class="on object-contain">
      </a>
    </div>

    <div class="logo w-full p-4">
      <img src="~@/assets/images/202407/LiveABC_logo.png" class="object-contain mx-auto">
    </div>

    <section class="main mx-auto main-bg-yellow pt-6 pb-10 md:py-16">
      <div class="banner w-full p-4 mb-24">
        <div class="container max-w-5xl">
          <div class="flex flex-col md:flex-row">
            <div class="p-2 order-2 md:order-1">
              <img src="~@/assets/images/202407/01-images-girl-mgs.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/01-images-girl-mgs-m.png" class="object-contain mx-auto md:hidden">
            </div>
            <div class="p-2 order-1 md:order-2">
              <img src="~@/assets/images/202407/01-TITLE.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex justify-center items-center flex-col md:flex-row">
            <div class="p-2 cursor-pointer" @click="toTop('#plan2')">
              <img src="~@/assets/images/202407/01-BABO-A-off.png" class="object-contain mx-auto">
            </div>
            <div class="p-2 cursor-pointer" @click="toTop('#plan3')">
              <img src="~@/assets/images/202407/01-BABO-B-off.png" class="object-contain mx-auto">
            </div>
            <div class="p-2 cursor-pointer" @click="toTop('#plan4')">
              <img src="~@/assets/images/202407/01-BABO-C-off.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="px-6 md:px-0 max-w-2xl mx-auto">
            <p class="md:text-lg py-4 text-center font-bold tracking-wider leading-loose">注意事項 : 7-ELEVEN、全家便利商店2大超商自由選100元購物金為LiveABC向PAYEASY 平台購買之電子票券，將於2024.9.30前統一以簡訊方式寄出。</p>
          </div>
        </div>
      </div>
      <div id="plan1" class="plan1 mb-8 md:mb-16 px-4 pt-24">
        <div class="container max-w-5xl bg-white p-3 md:p-6 pb-6 md:pb-10 inner-border rounded-xl">
          <div class="flex justify-center mb-4">
            <div class="md:p-2 -mt-24 md:-mt-32">
              <img src="~@/assets/images/202407/02-title-01.png" class="object-contain mx-auto">
            </div>
            <div class="md:p-2 md:-mt-32 hidden md:block">
              <img src="~@/assets/images/202407/02-BABO.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex justify-center mb-4 md:mb-8 items-center">
            <div class="md:p-2 w-2/3 md:w-auto">
              <img src="~@/assets/images/202407/02-title-02.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/02-title-02-m.png" class="object-contain mx-auto md:hidden">
            </div>
            <div class="md:p-2 md:hidden w-1/3">
              <img src="~@/assets/images/202407/02-BABO.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="mb-4">
            <router-link class="p-2 mb-4" :to="{ name: 'detail', params: { category: 'magazine', id: 8093 } }" target="_blank">
              <img src="~@/assets/images/202407/02-HIW.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/02-HIW-m.png" class="object-contain mx-auto md:hidden">
            </router-link>
            <router-link class="p-2 mb-4" :to="{ name: 'detail', params: { category: 'magazine', id: 8042 } }" target="_blank">
              <img src="~@/assets/images/202407/02-ABC.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/02-ABC-m.png" class="object-contain mx-auto md:hidden">
            </router-link>
            <a class="p-2 mb-4" href="https://store.liveabc.com/products/recent/sale?tag=386" target="_blank">
              <img src="~@/assets/images/202407/02-OTHER.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/02-OTHER-m.png" class="object-contain mx-auto md:hidden">
            </a>
          </div>
          <a class="p-2" href="https://store.liveabc.com/products/recent/sale?tag=386" target="_blank">
            <img src="~@/assets/images/202407/02-ORDER-MG-BOUTTON.png" class="object-contain mx-auto">
          </a>
        </div>
      </div>
      <div id="plan2" class="plan2 mb-8 md:mb-16 px-4 pt-24">
        <div class="container max-w-5xl bg-white p-6 pb-10 inner-border rounded-xl">
          <div class="flex justify-center mb-4">
            <div class="p-2 -mt-24 md:-mt-32">
              <img src="~@/assets/images/202407/03-title-01.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex justify-center mb-3 md:mb-8">
            <div class="p-2">
              <img src="~@/assets/images/202407/03-title-02.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/03-title-02-m.png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
          <div class="flex flex-col md:flex-row justify-center">
            <div class="order-2 md:order-1">
              <router-link class="p-2" :to="{ name: 'detail', params: { category: 'book', id: 8848 } }" target="_blank">
                <img src="~@/assets/images/202407/03-info-03.png" class="object-contain mx-auto hidden md:block">
                <img src="~@/assets/images/202407/m/03-info-03-m.png" class="object-contain mx-auto md:hidden">
              </router-link>
              <div class="flex flex-col md:flex-row">
                <a class="p-2"  href="https://store.liveabc.com/products/recent/sale?tag=387" target="_blank">
                  <img src="~@/assets/images/202407/03-PENINFO-BOUTTON.png" class="object-contain mx-auto">
                </a>
                <router-link class="p-2"  :to="{ name: 'detail', params: { category: 'book', id: 8848 } }" target="_blank">
                  <img src="~@/assets/images/202407/03-MORE-BOUTTON.png" class="object-contain mx-auto">
                </router-link>

              </div>
            </div>
            <div class="order-1 md:order-2 p-2">
              <img src="~@/assets/images/202407/03-livepen.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: 8848 } }" class="p-2 md:p-4 w-1/2 md:w-1/4 flex flex-col justify-center items-center" v-for="(item, index) in bookData1" :key="index">
              <div class="" :class="{ 'px-3': index === 1 || index === 3 }"><img :src="item.img_url" class="object-contain mx-auto"></div>
              <div v-if="index !== 0 && index !== 2">
                <div class="text-center price text-sm md:text-lg font-bold mt-2 md:mt-4">{{ item.title }}</div>
                <div class="text-center price text-lg md:text-2xl font-bold mt-1 md:mt-2">原價<span class="price-r">{{ item.old_price }}</span>元</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="plan3" class="plan3 mb-8 md:mb-16 px-4 pt-24">
        <div class="container max-w-5xl bg-white p-6 pb-10 inner-border rounded-xl">
          <div class="flex justify-center mb-4">
            <div class="p-2 -mt-24 md:-mt-32">
              <img src="~@/assets/images/202407/04-title-01.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex justify-center">
            <div class="p-2">
              <img src="~@/assets/images/202407/04-title-02.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="max-w-2xl mx-auto md:mb-8">
            <p class="md:text-lg py-4 text-center font-bold tracking-wider leading-loose">注意事項 : 7-ELEVEN、全家便利商店2大超商自由選100元購物金為LiveABC向PAYEASY平台購買之電子票券，將於2024.9.30前統一以簡訊方式寄出。</p>
          </div>
          <a class="p-2 mb-4" href="https://store.liveabc.com/products/recent/sale?tag=385" target="_blank">
            <img src="~@/assets/images/202407/04-MORE-BOUTTON.png" class="object-contain mx-auto">
          </a>
          <div class="p-2 mb-4">
            <img src="~@/assets/images/202407/04-title-03.png" class="object-contain mx-auto">
          </div>
          <div class="flex flex-wrap">
            <div class="p-4 w-1/2 md:w-1/4" v-for="(item, index) in bookData2" :key="index">
              <div><img :src="item.img_url" class="object-contain mx-auto"></div>
              <div class="text-center price text-lg md:text-2xl font-bold mt-1 md:mt-2">原價<span class="price-r">{{  item.old_price }}</span>元</div>
            </div>
          </div>
        </div>
      </div>
      <div id="plan4" class="plan4 px-4 py-24">
        <a class="container max-w-5xl bg-white p-6 pb-10 inner-border rounded-xl block" href="https://store.liveabc.com/products/recent/sale?tag=388" target="_blank">
          <div class="flex justify-center mb-4">
            <div class="p-2 -mt-24 md:-mt-32">
              <img src="~@/assets/images/202407/05-title-01.png" class="object-contain mx-auto">
            </div>
          </div>
          <div class="flex justify-center mb-8">
            <div class="p-2">
              <img src="~@/assets/images/202407/05-title-02.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/05-title-02-m.png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
          <div class="justify-center">
            <div class="p-2">
              <img src="~@/assets/images/202407/05-BABO.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/05-BABO-m.png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
          <div class="flex justify-center">
            <div class="p-2">
              <img src="~@/assets/images/202407/05-images-pc.png" class="object-contain mx-auto hidden md:block">
              <img src="~@/assets/images/202407/m/05-images-pc-m.png" class="object-contain mx-auto md:hidden">
            </div>
          </div>
        </a>
      </div>
    </section>

    <section class="footer py-8 md:py-12 bg-white">
      <p class="md:text-xl text-center tracking-wider mb-4 md:mb-10 px-12 md:px-0 font-black">活動內容以LiveABC官網發布為主。<span class="md:hidden"><br/></span>本公司保留活動修改、變更之權利。</p>
      <router-link :to="{ name: 'index' }" class="">
        <img src="~@/assets/images/202407/06-goto-liveabc-boutton.png" class="off object-contain mx-auto">
      </router-link>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'June2024',
  metaInfo () {
    return {
      title: '年中回饋雜誌最低價！購書滿額加送百元超商券',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      bookData1: [
        { id: 9440, img_url: require('@/assets/images/202407/book/03-B01.png'), title: '', old_price: 0 },
        { id: 9440, img_url: require('@/assets/images/202407/book/03-BABO-01.png'), title: '圖像記憶+點讀就發音', old_price: 399 },
        { id: 8742, img_url: require('@/assets/images/202407/book/03-B02.png'), title: '', old_price: 0 },
        { id: 8742, img_url: require('@/assets/images/202407/book/03-BABO-02.png'), title: '自然發音+KK音標一起學', old_price: 399 },
        { id: 7873, img_url: require('@/assets/images/202407/book/03-B03.png'), title: '考前高分寶典', old_price: 399 },
        { id: 7399, img_url: require('@/assets/images/202407/book/03-B04.png'), title: '金色證書就靠它', old_price: 450 },
        { id: 8465, img_url: require('@/assets/images/202407/book/03-B05.png'), title: '生活口說無負擔', old_price: 399 },
        { id: 8463, img_url: require('@/assets/images/202407/book/03-B06.png'), title: '高效率統整單字', old_price: 499 },
        { id: 7231, img_url: require('@/assets/images/202407/book/03-B07.png'), title: '西班牙語入門', old_price: 499 },
        { id: 8009, img_url: require('@/assets/images/202407/book/03-B08.png'), title: '日系職場必備', old_price: 399 },
        { id: 9534, img_url: require('@/assets/images/202407/book/03-B09.png'), title: '累積閱讀實力', old_price: 360 },
        { id: 8214, img_url: require('@/assets/images/202407/book/03-B10.png'), title: '學最實用英語', old_price: 450 }
      ],
      bookData2: [
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B01.png'), old_price: 399 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B02.png'), old_price: 499 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B03.png'), old_price: 420 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B04.png'), old_price: 499 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B05.png'), old_price: 450 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B06.png'), old_price: 399 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B07.png'), old_price: 480 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B08.png'), old_price: 420 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B09.png'), old_price: 450 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B10.png'), old_price: 499 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B11.png'), old_price: 550 },
        { id: 8537, img_url: require('@/assets/images/202407/book/04-B12.png'), old_price: 450 }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#July2024 {
  .main-bg-yellow {
    background-color: #fef161;
    background-image: url('~@/assets/images/202407/01-background.png');
    background-position: center top;
    background-repeat: no-repeat;
  }
  .menu {
    .menu_item {
      .hat {
        display: none;
        right: -5%;
        top: -25%;
      }
      &:hover {
        .hat {
          display: block;
        }
      }
    }
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
    .toggle-btn {
      top: 20%;
      right: -40%;
    }
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -164px;
    transition: 0.3s;
    .toggle-btn {
      top: 20%;
      right: -40%;
    }
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .banner {
    p {
      color: #333333;
    }
  }
  .inner-border {
    box-shadow: 6px 6px 0px 0px rgba(3, 72, 146, 1);
  }
  .price {
    color: rgba(3, 72, 146, 1);
  }
  .price-r {
    color: rgb(250, 135, 170);
  }
  .plan1 {
  }
  .plan2 {
  }
  .plan3 {
  }
  .plan4 {
  }
  .plan5 {
  }
  .footer {
  }
}
</style>
